import type { Dispatch, ReactNode } from "react";
import { createContext, useContext } from "react";

interface ModalContextType {
  isFullscreen: boolean;
  setIsFullscreen: Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

interface ModalProviderProps {
  children: ReactNode;
  value: ModalContextType;
}

const ModalContext = createContext<ModalContextType | null>(null);

export const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};

export const ModalProvider = ({ children, value }: ModalProviderProps) => (
  <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
);
